import api from "./api";

const getRedex = async () => {

    const response = await api.get("/api/redex");

    return response.data.data;

};

const addRedex = async(formData)=>{
    const response = await api.post(
        "/api/redex",
        formData
    );

    return response.data;

}

const updateRedex = async(id,formData)=>{

    const response = await api.put(
        `/api/redex/${id}`,
        formData
    );

    return response.data;

}

const deleteRedex = async(id)=>{

    const response = await api.delete(`/api/redex/${id}`);

    return response.data;

}

export default{
    getRedex,
    addRedex,
    updateRedex,
    deleteRedex
}